module.exports = __webpack_public_path__ + "media/images/icons/filled/ie-square-c33570597c3a08d23d4e156255f2ad8e.svg";